'use client';

import { cn } from '@utils/cn';
import type { GridItemStoryblok } from '@utils/storyblok/storyblok';
import { storyblokEditable } from '@utils/storyblok/storyblokEditable';
import { ClientStoryblokComponent } from '@common/storyblok/ClientStoryblokComponent';

export function GridItem({ blocks, ...props }: GridItemStoryblok) {
  // If all blocks are Images, wrap them in a positioned container for fill-based images
  const hasOnlyImages = (blocks?.length ?? 0) > 0 && blocks?.every((b) => b.component === 'Image');

  if (hasOnlyImages) {
    return (
      <div
        {...storyblokEditable(props)}
        className="relative h-full min-h-[360px] overflow-hidden"
      >
        {blocks?.map((blok) => (
          <ClientStoryblokComponent
            blok={blok}
            key={blok._uid}
          />
        ))}
      </div>
    );
  }

  return (
    <div
      {...storyblokEditable(props)}
      className={cn('h-full flex flex-col')}
    >
      {blocks?.map((blok) => (
        <ClientStoryblokComponent
          blok={blok}
          key={blok._uid}
        />
      ))}
    </div>
  );
}
